import Axios from "axios";
import React, { useEffect, useState } from "react";
import TeamDetails from "./TeamDetails";
import { useNavigate } from "react-router-dom";

const TeamCompiPage = ({ user, competition, setCompetition }) => {
    const navigate = useNavigate();
    const [teams, setTeams] = useState([]);
    const [csv, setCsv] = useState(
        ",Team ID,Name,MI Number,Phone,Email,College,City\n"
    );

    const getConfirmedTeams = () => {
        Axios.post(
            "https://ashish.moodi.org/multicity/get_conf_teams",
            {
                competition: competition.mcId,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        )
            .then((res) => {
                setTeams(res.data);
            })
            .catch((err) => console.error(err));
    };

    // const onSlottingClick = () => {
    //     Axios.post(
    //         `https://jarvis.moodi.org/multicity/mul_team_compi_slotting`,
    //         { competition: competition.mcId },
    //         {
    //             headers: {
    //                 "Content-Type": "application/json",
    //             },
    //         }
    //     )
    //         .then((res) => {
    //             if (res.data.status === "done") {
    //                 window.alert("sloting done");
    //                 setCompetition({ ...competition, isSlottingDone: 1 });
    //             }
    //         })
    //         .catch((err) => console.error(err));
    // };

    const download_team_csv = () => {
        var hiddenElement = document.createElement("a");
        hiddenElement.href = "data:text/csv;charset=utf-8" + encodeURI(csv);
        hiddenElement.target = "_blank";
        hiddenElement.download = `${competition.mcName}.csv`;
        hiddenElement.click();
        setCsv(",Team ID,Name,MI Number,Phone,Email,College,City\n");
    };

    useEffect(() => {
        getConfirmedTeams();
        // eslint-disable-next-line
    }, [competition]);

    return (
        <div className="container-fluid">
            <div className="row">
                <h2 className="text-center col-sm-3">{competition.mcName}</h2>
                <p className="col-sm-3 text-center">
                    Total registrations: {teams.length}
                </p>
                {user ? (
                    user.isAdminCooride ? (
                        <button
                            className="btn btn-primary col-sm-2"
                            onClick={download_team_csv}
                        >
                            Download CSV
                        </button>
                    ) : user.isSuperUser ? (
                        <button
                            className="btn btn-primary col-sm-2"
                            onClick={download_team_csv}
                        >
                            Download CSV
                        </button>
                    ) : (
                        <></>
                    )
                ) : (
                    <></>
                )}

                {user ? (
                    user.isHospi ? (
                        <button
                            className="btn btn-primary col-sm-2"
                            onClick={() =>
                                navigate(
                                    `/admin/multicity/slotting/${competition.mcId}`
                                )
                            }
                        >
                            Do Slotting
                        </button>
                    ) : user.isAdminCooride ? (
                        <button
                            className="btn btn-primary col-sm-2"
                            onClick={() =>
                                navigate(
                                    `/admin/multicity/slotting/${competition.mcId}`
                                )
                            }
                        >
                            Do Slotting
                        </button>
                    ) : user.isSuperUser ? (
                        <button
                            className="btn btn-primary col-sm-2"
                            onClick={() =>
                                navigate(
                                    `/admin/multicity/slotting/${competition.mcId}`
                                )
                            }
                        >
                            Do Slotting
                        </button>
                    ) : (
                        <></>
                    )
                ) : (
                    <></>
                )}

                {user ? (
                    user.isAdminCooride ? (
                        <button
                            className="btn btn-primary col-sm-2"
                            onClick={() =>
                                navigate(
                                    `/admin/mul/compi_score/${competition.mcId}`
                                )
                            }
                        >
                            View Score Sheet
                        </button>
                    ) : user.isCoordie ? (
                        <button
                            className="btn btn-primary col-sm-2"
                            onClick={() =>
                                navigate(
                                    `/admin/mul/compi_score/${competition.mcId}`
                                )
                            }
                        >
                            View Score Sheet
                        </button>
                    ) : user.isSuperUser ? (
                        <button
                            className="btn btn-primary col-sm-2"
                            onClick={() =>
                                navigate(
                                    `/admin/mul/compi_score/${competition.mcId}`
                                )
                            }
                        >
                            View Score Sheet
                        </button>
                    ) : (
                        <></>
                    )
                ) : (
                    <></>
                )}
            </div>
            <table className="container-fluid">
                <thead>
                    <tr className="row">
                        <th className="col-sm-2">Name</th>
                        <th className="col-sm-1">MI Number</th>
                        <th className="col-sm-1">Phone</th>
                        <th className="col-sm-3">Email</th>
                        <th className="col-sm-2">College</th>
                        <th className="col-sm-1">City</th>
                    </tr>
                </thead>
                <tbody>
                    {teams.map((team) => {
                        return (
                            <TeamDetails
                                teamId={team.mcTeamId}
                                csv={csv}
                                setCsv={setCsv}
                            />
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default TeamCompiPage;
